import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface CallSettings {
  messagingEnabled: boolean;
  voiceCallsEnabled: boolean;
  videoCallsEnabled: boolean;
  screenSharingEnabled: boolean;
  loading: boolean;
}

export function useCallSettings(): CallSettings {
  const [settings, setSettings] = useState<CallSettings>({
    messagingEnabled: true,
    voiceCallsEnabled: false,
    videoCallsEnabled: false,
    screenSharingEnabled: false,
    loading: true,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data, error } = await supabase
          .from('app_settings')
          .select('key, value')
          .in('key', ['messaging_enabled', 'voice_calls_enabled', 'video_calls_enabled', 'screen_sharing_enabled']);

        if (error) throw error;

        const settingsMap = new Map(data?.map(s => [s.key, s.value]) || []);
        
        setSettings({
          messagingEnabled: settingsMap.has('messaging_enabled') 
            ? (settingsMap.get('messaging_enabled') === true || settingsMap.get('messaging_enabled') === 'true')
            : true,
          voiceCallsEnabled: settingsMap.get('voice_calls_enabled') === true || settingsMap.get('voice_calls_enabled') === 'true',
          videoCallsEnabled: settingsMap.get('video_calls_enabled') === true || settingsMap.get('video_calls_enabled') === 'true',
          screenSharingEnabled: settingsMap.get('screen_sharing_enabled') === true || settingsMap.get('screen_sharing_enabled') === 'true',
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching call settings:', error);
        setSettings(prev => ({ ...prev, loading: false }));
      }
    };

    fetchSettings();
  }, []);

  return settings;
}